import flows5min from './flows5min';
import flows10min from './flows10min';
import flows20min from './flows20min';

export default [
  { id: '5min', flows: flows5min, userTime: 5 },
  { id: '10min', flows: flows10min, userTime: 10 },
  { id: '20min', flows: flows20min, userTime: 20 },
];
